import { stringFromJSONValue, unitStatusFromJSONValue } from './parser'
import { UnitStatus, unitStatusColor } from './UnitStatus'

export class UnitModel {
  id: string
  transportLocation: string
  status: UnitStatus
  overrideStatusToCleared: boolean

  public constructor(id: string, transportLocation: string, status: UnitStatus) {
    this.id = id
    this.transportLocation = transportLocation
    this.status = status
    this.overrideStatusToCleared = false
  }

  public resolvedUnitStatus(): UnitStatus {
    return this.overrideStatusToCleared ? 'AR' : this.status
  }

  public resolvedTransportLocation(): string {
    return this.status == 'TR' || this.status == 'TA' ? this.transportLocation : ''
  }

  public static modelFromJSON(json: any): UnitModel {
    return new UnitModel(
      stringFromJSONValue(json['UnitID']),
      stringFromJSONValue(json['TransportLocation']),
      unitStatusFromJSONValue(json['PulsePointDispatchStatus'])
    )
  }

  public displayID() {
    switch (this.resolvedUnitStatus()) {
      case 'DP':
        return `?${this.id}`
      case 'AE':
        return `^${this.id}`
      case 'SG':
        return `~${this.id}`
      default:
        return this.id
    }
  }

  public statusColor() {
    return unitStatusColor(this.resolvedUnitStatus())
  }

  public statusCategory(): UnitStatus {
    const unitStatus = this.resolvedUnitStatus()
    switch (unitStatus) {
      case 'DP':
      case 'AK':
        return 'DP'
      case 'SG':
      case 'OS':
      case 'AE':
        return 'OS'
      default:
        return unitStatus
    }
  }

  public formattedUnitDescription() {
    const transportLocation = this.resolvedTransportLocation()
    if (transportLocation === '') {
      return this.displayID()
    }
    return `${this.displayID()} (${transportLocation})`
  }
}
